const obj = {
    api: 'https://fnde-functions.azurewebsites.net/api',
    storage: 'https://fndepocstorage.blob.core.windows.net/publications'
}

export default obj;